// @flow
import types from "./types";
import type {Action} from "../DucksUtils";
import CurrentRideTypes from "../CurrentRide/types";

export type PickupDropoff = { lat: number, lng: number, address: string };

type MandatoryKeys = {|
    valid: boolean,
    timestamp: number,
    ride_cost: number,
    droppoff_location: PickupDropoff,
    eta: number,
    pickup_location: PickupDropoff,
    proposal_id: number,
    ride_cost_str: string,
|}

type OptionalKeys = {|
    accepted?: boolean,
|}

export const CurrentProposalDefault = Object.freeze({});

export type CurrentProposal = {...MandatoryKeys, ...OptionalKeys} | OptionalKeys;

const CurrentProposalReducer = (currentProposal: CurrentProposal = CurrentProposalDefault, action: Action): CurrentProposal => {
    const type = action.type;
    const payload = action.payload;
    switch (type) {
        case types.PROPOSAL_DATA_UPDATE:
            return {
                ...currentProposal,
                valid: true,
                ...payload,
            };
        case types.PROPOSAL_TIMEOUT:
            return {
                ...currentProposal,
                valid: false,
            };
        case CurrentRideTypes.RIDE_DATA_CLEAR:
        case types.PROPOSAL_DATA_CLEAR:
            return Object.freeze({});
        case types.PROPOSAL_ACCEPTED:
            return {
                ...currentProposal,
                accepted: true,
            };
        default:
            return currentProposal;
    }
};

export default CurrentProposalReducer;



// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentProposal/reducers.js